'use client';

import { useEffect } from 'react';

const RELOAD_FLAG = 'global-chunk-error-recovered';

function isChunkLoadError(error: unknown) {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : '';

  return message.includes('ChunkLoadError') || message.includes('Loading chunk');
}

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    if (!isChunkLoadError(error)) return;

    try {
      if (sessionStorage.getItem(RELOAD_FLAG)) return;
      sessionStorage.setItem(RELOAD_FLAG, '1');
    } catch {
      // Ignore storage errors and still attempt a reload once.
    }

    window.location.reload();
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div style={{ padding: '24px', fontFamily: 'sans-serif' }}>
          <h1>Application error</h1>
          <p>
            The app hit an unexpected error. Refresh the page if it does not recover
            automatically.
          </p>
        </div>
      </body>
    </html>
  );
}
